import React from 'react';
import moment from 'moment';

const CalendarMonthNavigator = ({
  minYear, maxYear, year, month, day, onChange,
}) => {
  const previousDisabled = month === 0 && year <= minYear;
  const nextDisabled = month === 11 && year >= maxYear;
  const handleChangeDate = (type, nbDays) => {
    const newDate = moment({ year, month, day });
    if (type === 'previous') {
      newDate.subtract(nbDays, 'days');
    } else {
      newDate.add(nbDays, 'days');
    }
    onChange({ year: newDate.year(), month: newDate.month(), day: newDate.date() });
  };
  return (
    <div>
      <button type="button" className="btn btn-xs btn-info previous pull-left" onClick={ handleChangeDate.bind(null, 'previous', 28) } disabled={ previousDisabled }>
        <i className="fa fa-angle-double-left"></i>
      </button>
      <button type="button" className="btn btn-xs btn-info next pull-right" onClick={ handleChangeDate.bind(null, 'next', 28) } disabled={ nextDisabled }>
        <i className="fa fa-angle-double-right"></i>
      </button>
    </div>
  );
};

export default CalendarMonthNavigator;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/CalendarMonthNavigator.jsx